import { memo, useCallback, useMemo } from 'react';
import { StationaryArea } from '@thive/fddm-types';
import { SelectInput } from '@common/components/inputs';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { getCommonOption } from '@/modules/common/helpers/commonValue';
import {
  createEmptyAreas,
  pushAreaToItsCollection,
} from '@/modules/floorplanDesign/helpers/helpers';
import { useTranslatedOptions } from '@/modules/common/hooks';

const STATIONARY_TYPE_OPTIONS: {
  labelKey: string;
  value: StationaryArea['stationaryType'];
}[] = [
  { labelKey: 'interface:properties.area.stationary_type_options.parking', value: 'PARKING' },
  { labelKey: 'interface:properties.area.stationary_type_options.charging', value: 'CHARGING' },
  { labelKey: 'interface:properties.area.stationary_type_options.insertion', value: 'INSERTION' },
  { labelKey: 'interface:properties.area.stationary_type_options.extraction', value: 'EXTRACTION' },
];

interface Props {
  selectedStationaryAreas: StationaryArea[];
}

function StationaryTypeComponent({ selectedStationaryAreas }: Props) {
  const stationaryTypeOptions = useTranslatedOptions(STATIONARY_TYPE_OPTIONS);
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const stationaryType = useMemo(() => {
    const values = selectedStationaryAreas.map((area) => area.stationaryType);
    return getCommonOption(values);
  }, [selectedStationaryAreas]);

  const onChange = useCallback(
    (newValue: StationaryArea['stationaryType']) => {
      const updatedAreas = createEmptyAreas();
      selectedStationaryAreas.forEach((area) => {
        pushAreaToItsCollection(updatedAreas, {
          ...area,
          stationaryType: newValue,
        });
      });
      fddmSvc.updateAreas(updatedAreas);
    },
    [selectedStationaryAreas, fddmSvc],
  );

  return (
    <SelectInput
      options={stationaryTypeOptions}
      onChange={onChange}
      value={stationaryType || null}
      showMixed
    />
  );
}

export const StationaryType = memo(StationaryTypeComponent);
